// React imports
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Components
import Container from "../components/Container";
import ModalContent from "../components/ModalContent.tsx";

// Contexte
import { useInTheGame } from "../utils/InTheGameContexte.tsx";

// Image
import sydo from "/sydo.png";

function Credits() {
  // Toggle Game pour affichage logo
  const { toggleGame } = useInTheGame();
  useEffect(() => {
    toggleGame(true);
  }, [toggleGame]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [linkHref, setLinkHref] = useState("");

  // Fonction pour gérer la confirmation avant de quitter la page
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Empêcher la navigation par défaut
    e.preventDefault();
    setLinkHref(e.currentTarget.href);
    setIsModalOpen(true);
  };

  return (
    <>
      <ModalContent
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        linkHref={linkHref}
      />

      <Container color="white">
        <section className="credits" id="credits">
          <h1 className="text-special text-special--red">Crédits</h1>
          <div className="credits__sydo">
            <p>Produit par</p>
            <Link
              to="https://sydo.fr/"
              target="_blank"
              onClick={handleLinkClick}
            >
              <img className="credits__logo" src={sydo} alt="Logo Sydo" />
            </Link>
            <div className="credits__sydo__text">
              <p className="text-page-semib">
                Agence de conseil en pégagogies innovantes
              </p>
              <p>31 rue Burdeau 69001, Lyon</p>
              <a
                className="credits__link"
                href="mailto:contact@sydo.fr"
                onClick={handleLinkClick}
              >
                contact@sydo.fr
              </a>
              <p>0616572513</p>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
}

export default Credits;
